"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _button = _interopRequireDefault(require("./button"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _modalContext = _interopRequireDefault(require("../../modal-context"));

// Core frontend.
// Views
// Core Utils
var Back = function Back(_ref) {
  var onClick = _ref.onClick;

  var _useContext = (0, _react.useContext)(_modalContext["default"]),
      dataElementPrefix = _useContext.dataElementPrefix;

  return _react["default"].createElement(_button["default"], {
    onClick: onClick,
    dataElementLocation: _taggingHelper.DataElementLocations.POP_UP,
    dataElementLabel: "".concat(dataElementPrefix, "-modal-back"),
    dataElementId: "".concat(dataElementPrefix, "-modal-back")
  }, _react["default"].createElement(_Icon["default"], {
    icon: "arrow_back"
  }));
};

Back.propTypes = {
  onClick: _propTypes["default"].func.isRequired
};
var _default = Back;
exports["default"] = _default;